import { render, staticRenderFns } from "./ContestProfile.vue?vue&type=template&id=20c8210c&"
import script from "./ContestProfile.vue?vue&type=script&lang=js&"
export * from "./ContestProfile.vue?vue&type=script&lang=js&"
import style0 from "./ContestProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports